import * as _utils from '@/assets/js/Utilities';
import { cloneDeep } from "lodash";

const getDefaultState = () => {
	return {
		action: {
			name: null,
			data: {},
		},
		scriptsLoaded: false,
		IDTList: [],
		ODTList: [],
		IDT: { initial: true },
		blockLoading: false,
	};
};

const App = {
	namespaced: true,

	state: getDefaultState(),
	mutations: {
		SET_SCRIPTS_LOADED: state => {
			state.scriptsLoaded = true;
		},
		SET_ACTION: (state, payload) => {
			state.action = payload;
		},
		RESET_STATE: state => {
			Object.assign(state, getDefaultState());
		},
		SET_IDT_LIST: (state, payload) => {
			state.IDTList = _utils.sortAlphabetically(cloneDeep(payload));
		},
		SET_ODT_LIST: (state, payload) => {
			state.ODTList = _utils.sortAlphabetically(cloneDeep(payload));
		},
		SET_ACTIVE_IDT: (state, payload) => {
			state.IDT = payload;
		},
		RESET_ACTIVE_IDT: state => {
			Object.assign(state.IDT, getDefaultState().IDT);
		},
		SET_BLOCK_LOADING: (state, payload) => {
			state.blockLoading = payload;
		},
	},
	actions: {
		resetState: ({ commit }) => {
			commit("RESET_STATE");
		},
		setAction: ({ commit }, payload) => {
			commit('SET_ACTION', payload);
		},
		setScriptsLoaded: ({ commit }) => {
			commit("SET_SCRIPTS_LOADED");
		},
		setIDTList: ({ commit }, payload) => {
			commit("SET_IDT_LIST", payload);
		},
		setODTList: ({ commit }, payload) => {
			commit("SET_ODT_LIST", payload);
		},
		setActiveIDT: ({ commit }, payload) => {
			commit("SET_ACTIVE_IDT", payload);
		},
		resetActiveIDT: ({ commit }) => {
			commit("RESET_ACTIVE_IDT");
		},
		setBlockLoading: ({ commit }, payload) => {
			commit("SET_BLOCK_LOADING", payload);
		},

		applyGrade: async ({ rootState, dispatch }, sourceAsset) => {
			dispatch("Loader/showProgressBar", "indeterminate", { root: true });

			let activeImage = rootState.Projects.image;
			let assetStoreData;

			await window.lutify.storeLastState();

			if (sourceAsset.type == "candidate") {
				assetStoreData = await window.lutify.fetchCandidate(sourceAsset);
			} else if (sourceAsset.type == "match") {
				assetStoreData = await window.lutify.fetchMatch(sourceAsset);
			}

			let lastState = await window.lutify.fetchLastState(activeImage);
			let blocks = [...assetStoreData.blocks];
			blocks[1] = lastState.blocks[1];
			blocks[blocks.length - 1] = lastState.blocks[lastState.blocks.length - 1];

			await window.lutify.applyCompare(blocks, "waitToLoad", false);

			if (loader.typeOfActiveMedia('raw') && assetStoreData.rawDevelopment) {
				vm.rawDevelopment.setValues(assetStoreData.rawDevelopment);
				await vm.rawDevelopment.developAndRender();
			}

			dispatch("Loader/showProgressBar", false, { root: true });
		},
	},
	getters: {},
};

export default App;
